// removed by extract-text-webpack-plugin
module.exports = {"searchContainer":"searchContainer--1gXgr","title":"title--34Vtz","searchResults":"searchResults--3dDSE"};